import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import { structuralClone, Entity, getNotificationType, ResponseType } from "../../assets/utilities";
import SvMoneyinput from "../../components/moneyinput/moneyinput.vue";

@Component({
	components: {
		SvMoneyinput,
	}
})
export default class MissionCostDetail extends Vue {
    @Prop()
    value!: any;

    @Prop({ default: true })
    showTransport!: boolean;

    @Prop({ default: false })
    readonly!: boolean;

    model = {
        CorporateFacility: {
            Id: null,
            BreakfastCount: null,
            LunchCount: null,
            DinnerCount: null,
            HotelCount: null,
            IntownCostsInSource: null,
            IntownCostsInDestination: null,
            IntercityCostsByPlane: null,
            IntercityCostsByTrain: null,
            IntercityCostsByBus: null,
            IntercityCostsByCar: null,
            DriverEmployeeId: null,
        },
        PerrsonalCost: {
            Id: null,
            BreakfastCount: null,
            LunchCount: null,
            DinnerCount: null,
            HotelCount: null,
            GuesthouseCount: null,
            CaravanCount: null,
            TentCount: null,
            
        },
	    Other: {
            Id: null,
            ExtraTimeSpent: null,
            AghmariDuration: null,
            OffshorePlatformMission: null,
            OtherCost: null,
          
         
        },
        DriverList: {
            Id: null,
            FullName:null,
        },
        DriverEmployeeId: null,
        klaimSystemTypeEmployeeTypeIds: false,
        
    };
   
   
    driverChange(e: any) {
        debugger;
      
        var selectedemployee = e.sender.dataItem(e.sender.select());
        this.model.DriverEmployeeId = selectedemployee.Id;
        this.model.CorporateFacility.DriverEmployeeId = selectedemployee.Id;
    }

    @Watch("value", { immediate: true, deep: true })
    async valueChange() {
        this.model = await structuralClone(this.value);
    }

    submit() {
        if (this.showTransport == false && this.model.klaimSystemTypeEmployeeTypeIds == true && (this.model.DriverEmployeeId == null || this.model.DriverEmployeeId == "" )) {
            //@ts-ignore
            this.$root.$children[0].popupNotificationWidget.show(this.$MessagesLibrary.get("PleaseSelectADeriver"),
                getNotificationType(ResponseType.Failed));
            return;
        }
        this.$emit("input", this.model);
    }
}
